import '../modules/perf-scaffold-sk';
import '../modules/triage-page-sk';
